import { fileApiService } from "../../api/apiService";
import Btn from "./Btn";

interface PdfBtnProps {
  size?: "sm" | "lg";
  fontSize?: "sm" | "md";
  path: string;
  fileName: string;
}

export default function PdfBtn({ size="sm", fontSize = "sm", path, fileName }: PdfBtnProps) {
  const getPdfDow = async () => {
    try {
      const response = await fileApiService.get<Blob>(path + "&down=1", {
        responseType: "blob" as ResponseType,
      });
      
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      throw error;
    }
  };
  
  return (
    <Btn
      type="button"
      color="pdf"
      title={size === "sm"? "PDF" : "PDF 다운로드"}
      size={size}
      fontSize={fontSize}
      onClick={getPdfDow}
    />
  );
}
